export default function Marquee({ items }) {
  const row = items.map((i) => `${i}  ·  `).join("");
  return (
    <div className="overflow-hidden border-y border-pine/10 py-5 select-none" aria-hidden="true" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((k) => (
          <span key={k} className="font-serif text-xl sm:text-2xl tracking-wide text-pine/60 italic pr-2">
            {row}
          </span>
        ))}
      </div>
    </div>
  );
}
